'use strict';
const TAG_FILTER_PREFIX = 'tag:',
	isSingleTagFilter = (filter) => {
		if (typeof filter === 'string') {
			return filter.startsWith(TAG_FILTER_PREFIX);
		}
		return false;
	},
	calculateTags = list => {
		const tagMap = {};
		if (!list || !list.length || !list.forEach) {
			return [];
		}
		list.forEach(file => {
			if (!file || !file.context || file.context.recycleBin) {
				return;
			}
			if (file.tags && file.tags.length) {
				file.tags.forEach(tag => tagMap[tag] = true);
			}
		});
		return Object.keys(tagMap).sort();
	},
	isTagFilter = filter => {
		if (!filter || !filter.length) {
			return false;
		}
		if (typeof filter === 'string') {
			return filter.startsWith(TAG_FILTER_PREFIX);
		}
		if (Array.isArray(filter)) {
			return filter.filter(isSingleTagFilter).length;
		}
		return false;
	},
	goldFileFilter = require('./gold-file-filter'),
	goldFileSort =  require('./gold-file-sort');


module.exports = {
	calculateTags: calculateTags,
	isTagFilter: isTagFilter,
	recalculateFileList: (files, goldFileListPreferences) => {
		files = files || [];
		const sortedList = goldFileSort(files, goldFileListPreferences.getSortType()),
			tags = (sortedList && sortedList.length && calculateTags(sortedList)) || [],
			filterType = goldFileListPreferences.getFilterType(),
			doInvert = goldFileListPreferences.getListFilterInvert(),
			hasQuickList = tags.length && filterType === 'default',
			quickList = (hasQuickList && goldFileSort(files, 'lastModifiedDescending').filter((item) => item && item.context && !item.context.recycleBin).slice(0, 5).slice(0, 5)) || [],
			filteredList = goldFileFilter(sortedList, filterType, quickList, doInvert),
			result = {
				listFilterInvert: !!doInvert,
				quickList: quickList,
				hasQuickList: !!hasQuickList,
				fileList: filteredList,
				tags: tags,
				filteredTags: [],
				visibleFiles: quickList.concat(filteredList)
			};
		if (doInvert) {
			result.filteredTags = result.tags;
		} else if (result.tags.length) {
			result.filteredTags = isTagFilter(filterType) ? calculateTags(result.visibleFiles) : result.tags;
		}
		return result;
	}
};
